function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
}, /*#__PURE__*/React.createElement("rect", {
  x: 159.5,
  y: 47.5,
  width: 159,
  height: 47,
  transform: "rotate(180 159.5 47.5)",
  fill: "#C4C4C4",
  stroke: "#FF6E61"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M156.9 -85.9997C156.9 -85.9997 117.539 6.97726 67.5112 0.124327C33.7813 -4.49846 24.6284 -63.2387 -14.5089 -85.9997",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.985 -85.9995C163.985 -85.9995 121.895 11.2864 67.6693 4.49514C31.3322 -0.0548035 20.6648 -61.1709 -22.03 -85.9995",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 -85.9997C173.509 -85.9997 126.256 15.5841 67.8269 8.86003C28.8776 4.37733 16.7059 -59.1034 -29.5463 -85.9997",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 -72.5516C173.509 -72.5516 124.767 20.403 68.2029 14.6876C29.6348 10.7932 15.9589 -45.829 -29.5463 -70.9994",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 -59.8259C173.509 -59.8259 123.278 25.2391 68.579 20.5155C30.3921 17.2207 15.2118 -33.277 -29.5463 -56.7272",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 -47.1066C173.509 -47.1066 121.784 30.0968 68.95 26.3426C31.1391 23.6529 14.4546 -20.7258 -29.5514 -42.4502",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 -34.3923C173.509 -34.3923 120.284 34.9719 69.3261 32.159C31.8862 30.0914 13.7075 -8.18533 -29.5463 -28.1838",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 -21.6838C173.509 -21.6838 118.78 39.8638 69.7022 37.9699C32.6333 36.541 12.9604 4.34955 -29.5463 -13.9287",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 -8.97548C173.509 -8.97548 117.276 44.7778 70.0732 43.7804C33.3753 43.0071 12.2083 16.8841 -29.5514 0.331749",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 3.72184C173.509 3.72184 115.771 49.7145 70.4492 49.5856C34.1172 49.4792 11.4612 29.4134 -29.5463 14.5868",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 16.4023C173.509 16.4023 114.267 54.6567 70.8253 55.3683C34.8643 55.9567 10.7141 41.9202 -29.5463 28.8195",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 29.0321C173.509 29.0321 112.758 59.5761 71.2014 61.1002C35.6063 62.4058 9.96707 54.3762 -29.5463 42.9957",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.509 41.4327C173.509 41.4327 111.253 64.2945 71.5724 66.6031C36.3483 68.6539 9.21492 66.6031 -29.5463 56.9485",
  stroke: "#FFEBDF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}));

function SvgIllustrationPattern1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 160 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationPattern1);
export default __webpack_public_path__ + "static/media/illustration-pattern-1.a7a94841.svg";
export { ForwardRef as ReactComponent };